














import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class AvailableWeekDay extends Vue {
  @PropSync('buttons', {}) buttonSync!: any

  @PropSync('days', {}) daySync!: any

  public buttons: any = [
    { name: 'S' },
    { name: 'M' },
    { name: 'T' },
    { name: 'W' },
    { name: 'T' },
    { name: 'F' },
    { name: 'S' },
  ];

  // public days:any[] =  [];

  public provide(item: any) {
    if (this.daySync.indexOf(item) === -1) {
      this.daySync.push(item);
    } else {
      this.daySync.splice(this.daySync.indexOf(item), 1);
    }
  }

  public contains(arr:any, item: any) {
    return arr.indexOf(item) !== -1;
  }
}

